export default {
  title: 'Studio (V2)',
  description: 'Bouw en beheer de restaurantwebsite met de nieuwe Website Studio.',
  retry: 'Opnieuw proberen',
  deleted: 'Project verwijderd.',
  errors: {
    load: 'Het Studio (V2)-project kon niet worden geladen.',
    create: 'Het project kon niet worden aangemaakt. Probeer het opnieuw.',
    delete: 'Het project kon niet worden verwijderd. Probeer het opnieuw.',
  },
  EmptyState: {
    title: 'Nog geen Studio (V2)-project',
    description:
      'Maak een project aan om de website te bouwen in de nieuwe Website Studio. Studio (V1) blijft ongewijzigd.',
    description_no_access: 'Een onboardingmanager kan het project voor dit merk aanmaken.',
    create: 'Project aanmaken',
  },
  ProjectCard: {
    unnamed: 'Naamloos project',
    edit: 'Bewerken in Studio',
    delete: 'Verwijderen',
    open: 'Openen',
    no_domain: 'Nog geen domein',
    fields: {
      uuid: 'UUID',
      domain: 'Domein',
      websites: 'Websites',
    },
    delete_confirm: {
      title: 'Dit project verwijderen?',
      description:
        'Hiermee worden het Studio (V2)-project en de bijbehorende websites verwijderd. Je kunt later een nieuw project aanmaken.',
      ok: 'Verwijderen',
      cancel: 'Annuleren',
    },
  },
};
